<template>
  <a
    :id="id"
    href="#"
    :class="`tw-flex  tw-justify-center tw-h-fit tw-pt-[8px] tw-pb-[8px] tw-pr-[20px]
    tw-pl-[20px] tw-rounded-[100px] tw-text-center !tw-text-white !tw-no-underline tw-text-[13px] tw-bg-[#387dff] tw-font-[500] tw-font-[Poppins] button ${
      disabled ? 'disabled' : ''
    } ${isLoading ? 'tw-cursor-not-allowed !tw-bg-[#387dff]' : ''}`"
  >
    <div v-if="!isLoading" ref="innerTextBtnRef">
      <span :class="`${subTitle ? 'tw-font-medium' : ''} ${cssButton}`">
        {{ title }}
      </span>
      <span v-if="subTitle">: {{ subTitle }}</span>
    </div>
    <div
      v-else
      :style="{ width: animationWidth + 'px' }"
      class="tw-flex tw-justify-center tw-h-[39px] tw-w-[39px] tw-text-[#FFF]"
    >
      <!-- eslint-disable vue/no-unused-refs -->
      <LottieAnimation
        ref="anim"
        :animation-data="progressAnimationDark"
        :auto-play="true"
        :loop="true"
      />
    </div>
  </a>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import ProgressAnimationDark from "../../assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";

@Component({
  components: {
    LottieAnimation: LottieAnimation,
  },
})
export default class Button1 extends Vue {
  @Prop({ required: false, default: "Button" }) readonly title: string = "";
  @Prop({ required: false }) readonly subTitle: string = "";
  @Prop({ required: false, default: true }) readonly disabled: boolean = true;
  @Prop({ required: false, default: false }) id = "";
  @Prop({ required: false, default: false }) readonly isLoading: boolean =
    false;

  @Prop({ required: false, default: "" }) readonly cssButton;

  public animationWidth = 0;
  public progressAnimationDark: any = ProgressAnimationDark;

  @Watch("isLoading")
  onLoadingChange(newValue: boolean) {
    if (newValue) {
      const innerTextBtnRef = this.$refs.innerTextBtnRef as HTMLButtonElement;
      this.animationWidth =
        innerTextBtnRef.getBoundingClientRect()["width"] || 0;
    }
  }
}
</script>

<style scoped>
.button {
  background: #387dff;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
}

.button:hover {
  background-color: #096cdb;
}

.disabled {
  pointer-events: none;
  background-color: #62a2f5;
  color: #666666;
}
</style>
